import { createContext, Dispatch, RefObject, SetStateAction } from "react";

import { TUseWavesurfer } from "@hooks/wafeform";

export type TBottomPlayer = {
  id: string;
  slug: string;
  isPlaying?: boolean;
};

export type TPlayerContext = {
  data: TBottomPlayer;
  setData: (song: TBottomPlayer) => void;
  setPlay: (isPlaying: boolean) => void;
  media?: HTMLMediaElement;
  setMedia: Dispatch<SetStateAction<HTMLMediaElement>>;
  openLoginDialog: boolean;
  setOpenLoginDialog: () => void;
  handleMediaControl: (controls: Partial<TUseWavesurfer>) => void;
  containerRef: RefObject<HTMLDivElement>;
  /**
   * Track-page wavesurfer container readiness signal. The track page renders
   * a placeholder while `isTrackLoading` is true and only mounts the
   * `<div ref={containerRef}>` once the data has loaded — but the
   * useWavesurfer effect can run before that happens. TrackComponent calls
   * this with `true` once its main content (with the waveform div) renders;
   * useWavesurfer reads the value as a dep so the effect re-runs when the
   * ref binds.
   */
  trackContainerReady: boolean;
  setTrackContainerReady: (ready: boolean) => void;
};

export const PlayerContext = createContext<TPlayerContext | null>(null);
